import { Grid, styled } from "@mui/material";
import { VscInfo } from "react-icons/vsc";

export const MultipleEventsContainer = styled(Grid)(() => ({
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  justifyContent: "flex-start",
}));

export const InfoIcon = styled(VscInfo)(() => ({
  color: "#475467",
}));

export const IconContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "4px",
}));

export const Wrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  paddingBottom: 16,
}));
